import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faDotCircle } from "@fortawesome/free-solid-svg-icons"
import { toBool } from "../../../utils/stringHelpers"

const BooleanCell = ({ value }) => {
  let yesIcon = <FontAwesomeIcon icon={faCheckCircle} color="green" />
  let noIcon = <FontAwesomeIcon icon={faDotCircle} color="red" />

  return !!toBool(value) ? yesIcon : noIcon
}

export default BooleanCell
